var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "filters" },
    [
      _c("el-input", {
        attrs: {
          placeholder: "Filtrar por email",
          clearable: "",
          size: "small",
        },
        on: { input: _vm.onChangeInput },
        model: {
          value: _vm.emailModel,
          callback: function ($$v) {
            _vm.emailModel = $$v
          },
          expression: "emailModel",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }